import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { RxLpComHowBonusIsCalculatedCalculations } from './RxLpComHowBonusIsCalculatedCalculations'
import { RxLpComHowBonusIsCalculatedInfo } from './RxLpComHowBonusIsCalculatedInfo'

export const HOW_BONUS_CALCULATED_ANCHOR = 'how-bonus-is-calculated'

export const RxLpComHowBonusIsCalculated: FC = () => {
  return (
    <div className="bg-light-brand-medium" id={HOW_BONUS_CALCULATED_ANCHOR}>
      <div className="container flex flex-col gap-6 px-4 py-9 tablet:py-12">
        <h2 className="text-center text-xl font-medium tablet:text-3xl">
          <FormattedMessage id="rx.com.bonus.title" />
        </h2>
        <div className="flex flex-col gap-6 text-dark-primary-max tablet:flex-row">
          <RxLpComHowBonusIsCalculatedInfo />
          <RxLpComHowBonusIsCalculatedCalculations />
        </div>
      </div>
    </div>
  )
}
